import React, { useEffect } from "react";

const VLibras = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://vlibras.gov.br/app/vlibras-plugin.js";
    script.async = true;

    script.onload = () => {
      console.log("Script VLibras carregado.");
      
      // Inicialize o VLibras diretamente após o carregamento do script
      if (window.VLibras && typeof window.VLibras.Widget === "function") {
        console.log("VLibras widget disponível. Inicializando...");
        new window.VLibras.Widget({
          avatar: "icaro",
          position: "bottom-right",
          opacity: 1.0,
        });
        console.log("VLibras inicializado com sucesso.");
      } else {
        console.error("VLibras Widget não encontrado.");
      }
    };

    script.onerror = () => {
      console.error("Erro ao carregar o script do VLibras.");
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default VLibras;